var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{style:(_vm.$vuetify.breakpoint.xs
      ? 'padding: 12px; margin: 4px'
      : 'padding: 14px; margin: 0 12px 0 12px')},[(_vm.loading)?_c('base-loading'):_vm._e(),(!_vm.loading)?_c('div',[_vm._t("prepend"),_vm._t("default"),_vm._t("append")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }